import React from 'react'
import PageContainer from '../Shared/LayoutComponents/PageContainer'

const NotFound = props => {
  return <PageContainer>NotFound here</PageContainer>
}

export default NotFound
